import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { OnlineStoreFormWrapperComponent } from '../components/online-store-form-wrapper/online-store-form-wrapper.component';
import { 
  OnlineStoreFormConfig,
  ONLINE_STORE_FORM_CONFIG
} from '../online-store.config';
import { PermissionService } from '@app/core/services/permission.service';

@Component({
  selector: 'app-online-store-view',
  standalone: true,
  imports: [OnlineStoreFormWrapperComponent],
  templateUrl: './online-store-view.component.html',
  styleUrls: ['./online-store-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineStoreViewComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly permissionService = inject(PermissionService);
  private readonly permissionCodes = toSignal(
    this.permissionService.userPermissions$,
    {
      initialValue: this.permissionService.getCurrentPermissions(),
    },
  );

  canUpdate = computed(() => {
    this.permissionCodes();
    return this.permissionService.canDoAction('channel.online_store.edit');
  });

  config: OnlineStoreFormConfig = {
    title: 'onlineStore.form.view_online_store',
    formFields: ONLINE_STORE_FORM_CONFIG.formFields,
    sectionButtons: ONLINE_STORE_FORM_CONFIG.sectionButtons,
    headerActions: ONLINE_STORE_FORM_CONFIG.headerActions,
    listRoute: '/channel/online-store'
  };

  ngOnInit(): void {
    // Component initialization - product list is now handled by online-store-form-wrapper
  }
}
